import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Description as ContractIcon, Add as AddIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface Props {
  onCreateClick?: () => void;
}

export const ContractsEmptyState: React.FC<Props> = ({ onCreateClick }) => {
  const navigate = useNavigate();

  const handleCreate = () => {
    if (onCreateClick) {
      onCreateClick();
    } else {
      navigate('/contracts/new');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 2,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          bgcolor: 'primary.light',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        <ContractIcon sx={{ fontSize: 40, color: 'primary.main' }} />
      </Box>
      <Typography variant="h6" gutterBottom>
        No contracts yet
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3, maxWidth: 400 }}>
        Create your first contract to start collecting e-signatures from your clients.
        Templates make it easy to reuse common agreements.
      </Typography>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleCreate}
      >
        Create Contract
      </Button>
    </Box>
  );
};

export default ContractsEmptyState;
